/*
 * Bandeau « Vente flash » : compte à rebours et fin de vente. La visibilité initiale est tranchée
 * avant le 1er paint par flash-sale-gate ; le bouton de code est géré par flash-sale-code.js.
 * Le DOM est relu à chaque usage, car l'éditeur peut re-rendre le header (shopify:section:load).
 */
(function () {
  if (window.__flashBannerBound) return;
  window.__flashBannerBound = true;

  var root = document.documentElement;
  var saleWindow = { start: 0, end: 0 };
  var preview = false;
  var tickTimeoutId = null;
  var timerActive = false;
  var ended = false;
  var retireTimeoutId = null;
  var FADE_FALLBACK_MS = 400;

  function all(selector) {
    return document.querySelectorAll(selector);
  }

  // Hors aperçu, seules les dates posées sur <html> par le gate font foi (FMD : aucune date).
  function readWindow() {
    var source = root.dataset;
    if (!source.flashEnd && root.classList.contains('flash-preview')) {
      var banner = document.querySelector('[data-flash-banner]');
      source = banner ? banner.dataset : {};
    }
    return { start: Number(source.flashStart) || 0, end: Number(source.flashEnd) || 0 };
  }

  // Au-delà de 24 h, les jours passent devant (« 7j 12:51:18 ») : « 180:51:18 » ne se lit pas.
  function formatRemaining(seconds, daySuffix) {
    var total = Math.max(0, Math.floor(seconds));
    var days = Math.floor(total / 86400);
    var parts = [Math.floor((total % 86400) / 3600), Math.floor((total % 3600) / 60), total % 60];
    var clock = parts
      .map(function (part) {
        return String(part).padStart(2, '0');
      })
      .join(':');
    return days > 0 ? days + daySuffix + ' ' + clock : clock;
  }

  // Au-delà de 48 h, la date de fin se lit mieux qu'un compte à rebours de plusieurs jours.
  var UNTIL_THRESHOLD_S = 48 * 3600;

  function formatEndDate() {
    return new Intl.DateTimeFormat(root.lang || 'fr', {
      day: '2-digit',
      month: '2-digit',
      timeZone: 'Europe/Paris',
    }).format(new Date(saleWindow.end * 1000));
  }

  // « Jusqu'au » en petit devant la date : l'ensemble tient dans la largeur du compte à rebours.
  function renderUntil(timer) {
    var date = formatEndDate();
    if (timer.dataset.flashUntilShown === date) return;
    var parts = (timer.dataset.flashUntil || '[date]').split('[date]');
    var prefix = document.createElement('span');
    prefix.className = 'flash-banner__timer-prefix';
    prefix.textContent = parts[0].trim();
    timer.replaceChildren(prefix, document.createTextNode(date + (parts[1] || '')));
    timer.dataset.flashUntilShown = date;
  }

  function renderTimers(seconds) {
    var until = seconds > UNTIL_THRESHOLD_S;
    all('[data-flash-timer]').forEach(function (timer) {
      timer.classList.toggle('flash-banner__timer--until', until);
      if (until) {
        renderUntil(timer);
        return;
      }
      delete timer.dataset.flashUntilShown;
      var text = formatRemaining(seconds, timer.dataset.flashDays || 'j');
      if (timer.textContent !== text) timer.textContent = text;
    });
  }

  // Un `resize` global ramènerait un sticky déjà défilé en haut : repli si le composant manque.
  function refreshStickyElements() {
    if (!window.customElements || !window.customElements.get('sticky-element')) {
      window.dispatchEvent(new Event('resize'));
      return;
    }
    all('sticky-element').forEach(function (el) {
      el.updateCachedDimensions();
      el.checkAndSetSticky();
    });
  }

  function isHidden() {
    return document.visibilityState === 'hidden';
  }

  function setFlashOn(on) {
    if (root.classList.contains('flash-on') === on) return;
    root.classList.toggle('flash-on', on);
    if (!on) root.classList.remove('flash-ended');
    refreshStickyElements();
  }

  function cancelRetire() {
    clearTimeout(retireTimeoutId);
    document.removeEventListener('transitionend', onFadeEnd);
  }

  function retire() {
    cancelRetire();
    setFlashOn(false);
  }

  function onFadeEnd(event) {
    if (event.propertyName === 'opacity' && event.target.closest('.flash-banner')) retire();
  }

  // Le contenu s'efface (flash-ended), puis le bandeau habituel reprend sa place.
  function retireAfterFade() {
    cancelRetire();
    document.addEventListener('transitionend', onFadeEnd);
    retireTimeoutId = setTimeout(retire, FADE_FALLBACK_MS);
  }

  function stopTimer() {
    clearTimeout(tickTimeoutId);
    timerActive = false;
  }

  // Les boutons désactivés signalent la fin de vente à flash-sale-code.js. En aperçu éditeur,
  // le bandeau fini reste affiché jusqu'au rechargement.
  function endSale() {
    ended = true;
    stopTimer();
    renderTimers(0);
    all('[data-flash-code-button]').forEach(function (button) {
      button.disabled = true;
    });
    if (!root.classList.contains('flash-on')) return;
    root.classList.add('flash-ended');
    if (!preview) retireAfterFade();
  }

  function tick() {
    if (!timerActive) return;
    var now = Date.now() / 1000;
    if (preview && !saleWindow.end) {
      renderTimers(0);
      stopTimer();
      return;
    }
    if (now >= saleWindow.end) {
      endSale();
      return;
    }
    // Apparition onglet caché seulement : pas de saut de mise en page sous les yeux du client.
    if (!preview && now >= saleWindow.start && isHidden()) setFlashOn(true);
    renderTimers(saleWindow.end - now);
  }

  // Calé sur le changement de seconde de l'horloge, pour que l'affichage ne saute pas de chiffre.
  function scheduleTick() {
    tickTimeoutId = setTimeout(onTickTimeout, 1000 - (Date.now() % 1000));
  }

  function onTickTimeout() {
    tick();
    if (timerActive) scheduleTick();
  }

  function startTimer() {
    stopTimer();
    cancelRetire();
    ended = false;
    root.classList.remove('flash-ended');
    saleWindow = readWindow();
    preview = root.classList.contains('flash-preview');
    if (!document.querySelector('[data-flash-timer]') || (!preview && !saleWindow.end)) return;
    timerActive = true;
    tick();
    if (timerActive) scheduleTick();
  }

  function onVisibilityChange() {
    if (!ended) tick();
  }

  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', startTimer);

  startTimer();
})();
